import { TextField } from "../../../../shared/ui";
import { Controller } from "react-hook-form";

import type { FieldValues, UseControllerProps } from "react-hook-form";

interface VacancyControlInputTextProps<T extends FieldValues> extends UseControllerProps<T> {
    placeholder: string;
    onChangeFill: () => void; 
}

export const VacancyControlInputText = <T extends FieldValues>({ name, placeholder, control, onChangeFill }: VacancyControlInputTextProps<T>) => (
    <Controller
        name={name}
        control={control}
        render={({ field: { onChange, ...props }, fieldState: { error } }) => (
            <TextField
                autoComplete="off"
                placeholder={placeholder}
                errorMessage={error?.message}
                onChange={(event) => {
                    onChange(event);
                    onChangeFill();
                }}
                {...props}
            />
        )}
    />
);
